import ProductPageHeader from './ProductPageHeader';

export default ProductPageHeader;
